<style></style>
<template>
  <div class="col-lg-9">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <table class="board_table">
          <tr>
            <th>제목</th>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="제목을 입력하세요."
                v-model="title"
              />
            </td>
          </tr>
          <tr>
            <th>카테고리</th>
            <td style="text-align: left">
              <form class="form-inline">
                <div class="form-group mb-2 se_form">
                  <select
                    v-model="firstselected"
                    class="custom-select flex_center"
                    style="width: 160px; display: inline"
                    @change="viewSecond()"
                  >
                    <option
                      v-for="firstlist in firstlists"
                      :value="firstlist.No"
                      v-bind:key="firstlist.No"
                    >
                      {{ firstlist.Main }}
                    </option>
                  </select>
                  <select
                    v-model="subselected"
                    class="custom-select flex_center"
                    style="width: 180px; display: inline"
                    @change="viewVol()"
                  >
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.No"
                      v-bind:key="sublist.No"
                    >
                      {{ sublist.Sub }}
                    </option>
                  </select>
                  <select
                    v-model="volselected"
                    class="custom-select flex_center"
                    style="width: 100px; display: inline"
                  >
                    <option
                      v-for="vollist in vollists"
                      :value="vollist.No"
                      v-bind:key="vollist.No"
                    >
                      {{ vollist.Vol }}
                    </option>
                  </select>
                </div>
              </form>
            </td>
          </tr>
          <tr>
            <th>도구</th>
            <td style="text-align: left">
              <div v-if="editor" style="display: block">
                <button
                  class="btn btn-secondary btn-sm"
                  @click="editor.chain().focus().toggleBold().run()"
                  :class="{ active: editor.isActive('bold') }"
                >
                  <i class="bi bi-type-bold"></i>
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="editor.chain().focus().toggleItalic().run()"
                  :class="{ active: editor.isActive('italic') }"
                >
                  <i class="bi bi-type-italic"></i>
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="editor.chain().focus().toggleStrike().run()"
                  :class="{ 'is-active': editor.isActive('strike') }"
                >
                  <i class="bi bi-type-strikethrough"></i>
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="editor.chain().focus().setParagraph().run()"
                  :class="{ active: editor.isActive('paragraph') }"
                >
                  <i class="bi bi-text-paragraph"></i>
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="editor.chain().focus().toggleBulletList().run()"
                  :class="{ active: editor.isActive('bulletList') }"
                >
                  <i class="bi bi-list"></i>
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="upload('image')"
                >
                  <i class="bi bi-image"></i> 이미지삽입
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="upload('file')"
                >
                  <i class="bi bi-file-earmark-arrow-up-fill"></i> 파일첨부
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="addLink()"
                  :class="{ active: editor.getAttributes('link').href }"
                >
                  <i class="bi bi-link"></i> Link
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <th>내용</th>
            <td>
              <div style="min-height: 300px" class="write_box">
                <editor-content
                  :editor="editor"
                  style="
                    height: 400px;
                    width: 100%;
                    max-width: 100%;
                    padding: 20px;
                    background: #f8f8f8;
                    border: 1px solid #f0f0f0;
                  "
                  class="editor"
                />
              </div>
            </td>
          </tr>
        </table>
        <div class="flex_center">
          <button class="btn btn-danger" @click="addArticle()">
            글 올리기
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="main-card mb-3 card">
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-3";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";

import StarterKit from "@tiptap/starter-kit";
import axios from "axios";

export default {
  components: {
    EditorContent,
  },
  mounted() {
    this.editor = new Editor({
      content: "",
      extensions: [StarterKit, Image, Link],
    });

    if (this.$route.params.article) {
      this.creating = false;
      axios
        .get(
          "/boards/" +
            this.$route.params.board +
            "/articles/" +
            this.$route.params.article
        )
        .then((response) => {
          if (response.data.error) {
            alert("게시글을 불러올 수 없습니다.\n" + response.data.error);
          } else {
            this.title = response.data.result.title;
            this.content = response.data.result.content;
            this.volselected = response.data.result.cate_id;
            this.firstselected = response.data.result.cate_id;
            this.secondselected = response.data.result.cate_id;
            this.viewSecond();
            this.viewVol();
            this.editor.commands.setContent(response.data.result.content);
          }
        });
    }

    axios.get("/boards/files_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
  data() {
    return {
      creating: true,
      title: "",
      content: "",
      firstlists: [],
      firstselected: "",
      subselected: "",
      sublists: [],
      volselected: "",
      vollists: [],
      editor: null,
    };
  },
  methods: {
    upload(type) {
      {
        var input = document.createElement("input");
        input.type = "file";
        if (type == "image") {
          input.accept = "image/*";
        }

        input.onchange = (e) => {
          const uploadFile = e.target.files[0];
          const formData = new FormData();
          formData.append("userfile", uploadFile);

          axios({
            method: "post",
            url: "https://s.mypathkr.com/upload",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              //this.editor.commands.clearContent();.
              if (type == "image") {
                this.editor
                  .chain()
                  .focus()
                  .setImage({
                    src: response.data.url,
                  })
                  .run();
              } else {
                this.editor
                  .chain()
                  .focus()
                  .insertContent(
                    '<a href="' +
                      response.data.url +
                      '">📁 ' +
                      uploadFile.name +
                      "</a><br><br>"
                  )
                  .run();
              }

              //this.changedData.image = response.data.url
            }
          });
        };

        input.click();
      }
    },
    addLink() {
      if (this.editor.getAttributes("link").href)
        this.editor.commands.unsetLink();
      var lnk = prompt("URL을 입력하세요.");
      if (!lnk) return;

      this.editor.commands.toggleLink({
        href: "lnk",
      });
    },
    addArticle() {
      var data = {
        title: this.title,
        content: this.editor.getHTML(),
        cate_id: this.volselected,
      };
      var send = axios({
        method: this.creating ? "post" : "patch",
        url:
          "/boards/files/articles" +
          (!this.creating ? "/" + this.$route.params.article : ""),
        data: data,
      });

      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    viewSecond() {
      axios
        .get("/boards/files_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
    viewVol() {
      axios
        .get(
          "/boards/files_categories/" +
            this.firstselected +
            "/" +
            this.subselected
        )
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.vollists = response.data.result;
          }
        });
    },
  },
};
</script>
